import {_} from 'lodash';
import * as ko from "knockout";
import {IKnockoutComponent, TBaseOrObservableType} from "../../index";
import menuHtml from './menu.html?raw';

export const template = menuHtml;

export interface IDropdownMenuItem {
    onClick: Function
    description?: TBaseOrObservableType<string> | (() => string)
    disabled?: TBaseOrObservableType<boolean> | (() => boolean)
    enabled?: TBaseOrObservableType<boolean> | (() => boolean)
    icon: TBaseOrObservableType<string> | (() => string)
    label: TBaseOrObservableType<string> | (() => string)
    validator?: (...args: any[]) => boolean
}

export interface IDropdownMenu {
    items?: IDropdownMenuItem[] | KnockoutObservableArray<IDropdownMenuItem>
    component?: IKnockoutComponent
}

export class DropdownMenu {

    readonly items: IDropdownMenuItem[] | KnockoutObservableArray<IDropdownMenuItem>
    private component: IKnockoutComponent;
    button_tt: string = 'pull down menu'

    constructor(params: IDropdownMenu) {
        this.items = params.items ?? []
        this.component = params.component!
    }

    private isEnabled(item: IDropdownMenuItem): boolean {
        if ('enabled' in item) {
            return this.getValue(item.enabled)
        }
        if ('disabled' in item) {
            return !this.getValue(item.disabled)
        }
        return true;
    }

    private getValue(value: TBaseOrObservableType<any> | (() => any)): any {
        const enabled = ko.unwrap(value);
        return _.isFunction(value)
            ? value()
            : value
    }

}
